import { AxiosRequest, instance } from '@myme/utils';
import { getEnvValue } from './getEnvValue';

export interface KeyValuePair {
  key: string;
  value: string | boolean;
}

interface Options<T> {
  reqBody?: T;
  args?: KeyValuePair[];
  queryStringParams?: KeyValuePair[];
}

export const sendRequest = async <TRes, TReqBody>(request: AxiosRequest, options?: Options<TReqBody>) => {
  if (isRequestWithoutArgs(request.path)) {
    return instance[request.method]<TRes>(addQueryString(request.path, options?.queryStringParams), options?.reqBody);
  }

  if (!options?.args) {
    throw Error('Invalid request setup');
  }

  return instance[request.method]<TRes>(
    addQueryString(replacePathArgs(request.path, options.args), options.queryStringParams),
    options.reqBody
  );
};

const isRequestWithoutArgs = (path: string) => !path.includes(':');

const replacePathArgs = (path: string, args: KeyValuePair[]) => {
  args.forEach(arg => {
    // eslint-disable-next-line no-param-reassign
    path = path.replace(`:${arg.key}`, `${arg.value}`);
  });

  return path;
};

const addQueryString = (path: string, queryStringParams: KeyValuePair[] | undefined) => {
  if (!queryStringParams) {
    return path;
  }

  const url = new URL(`${getEnvValue('REACT_APP_API_URL')}${path}`);
  const params = url.searchParams;

  queryStringParams.forEach(param => {
    if (param.value) {
      params.append(param.key, `${param.value}`);
    }
  });

  return url.toString();
};
